import styled from 'styled-components'

export const Name = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Info = styled.div`
  margin-top: var(--space-100);
  color: var(--text-secondary);
  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);
  letter-spacing: var(--font-letter-spacing-looser);
`
